/**
 * @var service.ready
 * @var service.banners
 * @param variables {{ recaptcha: object, profiles: object }}
 * @todo - https://stackoverflow.com/questions/21399872/how-to-detect-whether-html5-video-has-paused-for-buffering
 */

const BunnyController =  ['$scope', '$http', '$lazyScripts', function($scope, $http, $lazyScripts) {

    let vastClient = null;
    let vastTracker = null;

    let vastPostRollClient = null;
    let vastPostRollTracker = null;

    let myContainer = null;
    let myOverlayDesktop = null;
    let myOverlayMobile = null;
    let myVideo = null;
    let myRange = null;
    let myVolume = null;
    let myPreview = null;

    $scope.rollOrVideo = (event) => {
        $scope.bunny.loading = true;
        $lazyScripts.loadVast().then(() => {

            if ( $scope.service.preRoll.visible ) {
                vastClient = new VAST.VASTClient();
                vastClient.get($scope.service.preRoll.vast).then(res => {
                    if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
                        $scope.bunny.loading = false;
                        $scope.bunny.playPause();
                        return false;
                    }
                    vastTracker = new VAST.VASTTracker(vastClient, res.ads[0], res.ads[0].creatives[0]);
                    vastTracker.load();

                    $scope.roll.available = true;
                    $scope.roll.media = res.ads[0].creatives[0].mediaFiles[0];
                    $scope.roll.clickthrough = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;
                    if ( $scope.service.preRoll.autoplay ) {
                        $scope.roll.autoplay();
                    }
                    $scope.$apply();

                    $scope.bunny.volume(0);
                    setTimeout(() => {
                        if (localStorage.getItem("bunny-volume") !== null ) {
                            $scope.bunny.volume( parseFloat(localStorage.getItem("bunny-volume")));
                            myVolume.value = parseFloat(localStorage.getItem("bunny-volume"));
                            document.documentElement.style.setProperty('--bunny-volume', (myVideo.volume*100) + "%");
                        } else {
                            $scope.bunny.volume(1);
                        }
                        $scope.bunny.loading = false;
                        $scope.roll.play();
                    }, 250 );
                }).catch((err) => {
                    $scope.bunny.loading = false;
                    $scope.bunny.playPause();
                });

            } else {
                $scope.bunny.loading = false;
                $scope.bunny.playPause();
            }

            // Post roll check
            if ( $scope.service.postRoll.visible ) {
                vastPostRollClient = new VAST.VASTClient();
                vastPostRollClient.get($scope.service.postRoll.vast).then(res => {
                    if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
                        return false;
                    }
                    vastPostRollTracker = new VAST.VASTTracker(vastPostRollClient, res.ads[0], res.ads[0].creatives[0]);
                    vastPostRollTracker.load();

                    $scope.postRoll.available = true;
                    $scope.postRoll.media = res.ads[0].creatives[0].mediaFiles[0];
                    $scope.postRoll.clickthrough = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;

                    $scope.$apply();
                }).catch((err) => {
                    $scope.postRoll.available = false;
                });

            }
        });
    };

    $scope.bunny = {
        videoElement: null,
        ios: "NU",
        fullscreen: false,
        started: false,
        loaded: false,
        loading: false,
        ended: false,
        buffered: {
            length: 0,
            start: 0,
            end: 0,
            ratio: 0
        },
        paused: true,
        playing: false,
        initiated: false,
        switching: {
            active: false,
            time: 0,
        },
        muted: false,
        duration: {
            total: null,
            played: null,
            ratio: 0,
        },
        sources: {
            visible: false,
            available: {},
        },
        poster: null,
        preview: {
            breakpoints: [10,20,30,40,50,60,70,80,90,100],
            slices: [],
            duration: 0,
            current: 0,
            previous: -1,
            percentage: 0,
            url: null,
            time: null,
        },
        controls: {
            visible: false,
            timeout: 0,
        },
        arrows: {
            backwards: false,
            forwards: false,
        },
        bubbles: {
            index: 0,
            length: 0,
            interval: 0,
            timeout: 0,
            restartOne: 0,
            restartTwo: 0,
            time: {
                visible: 10000,
                hidden: 30000,
            }
        },
        hls: {
            native: false,
            supported: false,
            instance: null,
        },
        volume(value) {
            myVideo.volume = value;
        },
        resume() {
            this.paused = false;
            myVideo.play();
        },
        showControls() {
            clearTimeout(this.controls.timeout);
            myContainer.dataset.active = "true";
            this.controls.visible = true;
        },
        hideControls( timeout = 3000) {
            clearTimeout(this.controls.timeout);
            this.controls.timeout = setTimeout(() => {
                myContainer.dataset.active = "false";
                myPreview.parentNode.style.display = 'none';
                this.sources.visible = false;
                this.controls.visible = false;
                $scope.$apply();
            }, timeout);
        },
        playPause() {
            // Track clicks
            if (!this.started) {
                $http.get('/service/player-click.json');
                this.bubbleEvents(5000);
            }
            if (myVideo.paused) {
                this.started = true;
                this.paused = false;
                this.ended = false;
                myVideo.play();
                this.hideControls();
                this.bubbleEvents(5000);
            } else {
                this.showControls();
                this.paused = true;
                myVideo.pause();
            }
        },

        toggleMuted() {
            myVideo.muted = !myVideo.muted;
            this.muted = myVideo.muted;
            localStorage.setItem('bunny-muted', this.muted);
        },
        toggleSources() {
            if (this.sources.visible) {
                this.hideControls(0);
            } else {
                this.showControls();
            }
            this.sources.visible = !this.sources.visible;
        },
        changeSource(item) {
            if ( item.type === 'link') {
                window.location.href = item.link;
                return false;
            }
            angular.forEach(this.sources.available, (source) => {
                source.default = false;
            });
            item.default = true;
            this.sources.visible = false;
            this.switching = {
                active: true,
                time: myVideo.currentTime,
            };
            myVideo.pause();
            if ( this.hls.instance ) {
                //$scope.bunny.hls.instance.detachMedia();
                //$scope.bunny.hls.instance.loadSource(item.link);
                $scope.bunny.hls.instance.loadSource(item.link);
            } else {
                myVideo.src = item.link;
                myVideo.load();
            }

        },
        detectFullScreen() {
            return window.innerHeight === screen.height || ((screen.availHeight || screen.height-30) <= window.innerHeight);
        },
        makeFullScreen() {
            console.log("Full");
            // Ios specific
            if ( myVideo.webkitEnterFullScreen && this.iOS()) {
                myVideo.webkitEnterFullScreen();
                return false;
            }

            if ( this.fullscreen === false ) {
                const requestFullScreen = myContainer.requestFullscreen || myContainer.webkitEnterFullScreen || myContainer.webkitRequestFullScreen || myContainer.mozRequestFullScreen || myContainer.msRequestFullScreen;
                requestFullScreen.call(myContainer);
                this.fullscreen = true;
            } else {
                const cancelFullScreen = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                cancelFullScreen.call(document);
                this.fullscreen = false;
            }



        },

        iOS() {
            return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        },

        init() {

            myVideo = this.videoElement;
            myContainer = document.getElementById("video-player");
            myOverlayDesktop = myContainer.querySelector("[data-overlay-desktop]");
            myOverlayMobile = myContainer.querySelector("[data-overlay-mobile]");
            myRange = myContainer.querySelector(".video-range");
            myVolume = myContainer.querySelector(".video-volume");
            myPreview = myContainer.querySelector(".bunny-preview-video");
            myPreview.src = this.preview.url;

            myVideo.addEventListener('canplay',() => {
                if ( this.switching.active ) {
                    myVideo.currentTime = this.switching.time;
                    if ( this.paused === false ) {
                        myVideo.play();
                    }
                    this.switching.active = false;
                    $scope.$apply();
                }
            });

            myVideo.addEventListener('durationchange', () => {
                this.duration.total = this.toHHMMSS(myVideo.duration);
                this.duration.played = this.toHHMMSS(myVideo.currentTime);
                myRange.max = parseInt(myVideo.duration);
            });

            myVideo.addEventListener('loadedmetadata',() =>{
                this.duration.total = this.toHHMMSS(myVideo.duration);
                this.duration.played = this.toHHMMSS(myVideo.currentTime);
                this.loaded = true;
                myRange.max = parseInt(myVideo.duration);

                if (localStorage.getItem("bunny-volume") !== null ) {
                    myVideo.volume = parseFloat(localStorage.getItem("bunny-volume"));
                }
                if (localStorage.getItem("bunny-muted") !== null ) {
                    myVideo.muted = localStorage.getItem("bunny-muted") === 'true';
                    this.muted = myVideo.muted;
                }
                document.documentElement.style.setProperty('--bunny-volume', (myVideo.volume*100) + "%");
                myVolume.value = myVideo.volume;
                $scope.$apply();
            });

            let progress = [];

            myVideo.addEventListener('timeupdate', () => {
                this.duration.played = this.toHHMMSS(myVideo.currentTime);
                this.duration.ratio = parseFloat(myVideo.currentTime / myVideo.duration * 100).toFixed(2)
                //document.getElementById("demo").innerHTML = myVideo.currentTime + ' din total ' + myVideo.duration + ' procent ' + ( $percent )  + "%";
                myRange.value = myVideo.currentTime;
                //document.getElementById("video-range").style.setProperty('--value', myVideo.currentTime);
                // document.getElementById("video-progress").style.width = $percent + "%";
                document.documentElement.style.setProperty('--bunny-ratio', this.duration.ratio + "%");
                if (!this.hls.instance ) {
                    this.buffered = {
                        length: myVideo.buffered.length,
                        start: myVideo.buffered.start(0),
                        end: myVideo.buffered.end(0),
                        ratio: parseFloat(myVideo.buffered.end(0) / myVideo.duration * 100).toFixed(2)
                    };
                    document.documentElement.style.setProperty('--bunny-buffer', this.buffered.ratio + "%");
                }
                if (!$scope.modules.visible() && this.controls.visible && parseInt(myVideo.currentTime)%1 === 0 && !progress[parseInt(myVideo.currentTime)]) {
                    progress[parseInt(myVideo.currentTime)] = true;
                    $scope.$apply();
                }
                // console.log($scope.modules.visible());
            });

            myVideo.addEventListener("seeked", (e) => {
                progress = [];
                this.bubbleEvents(0)
            });

            myVideo.addEventListener("ended", () => {
                this.paused = true;
                this.ended = true;
                this.showControls();
                $scope.$apply();
                // Play the post-roll if available
                if ( $scope.postRoll.available ) {
                    $scope.postRoll.play();
                }
            });

            // myVideo.addEventListener("progress", (e) => {
            //     const buffered = e.target.buffered.end(0);
            //     const duration = e.target.duration;
            //     const buffered_percentage = (buffered / duration) * 100;
            //     console.log(buffered_percentage);
            // }, { passive: true });


            // document.fullscreenElement will point to the element that is in fullscreen mode if there is one.
            // If there isn't one, the value of the property is null.

            ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach((eventName) => {
                document.addEventListener(eventName, () => {
                    this.fullscreen = document.fullscreenElement !== null;
                    if (!this.fullscreen) {
                        this.showControls();
                        this.fullscreen = false;
                        this.paused = true;
                        myVideo.pause();
                        $scope.$apply();
                    }
                });

            });

            // document.addEventListener("webkitExitFullScreen", () => {
            //     console.log("document webkitExitFullScreen");
            // });
            // document.addEventListener("webkitendfullscreen", () => {
            //     console.log("document webkitendfullscreen");
            // });
            //
            // // iOS specific
            //
            // myVideo.addEventListener("webkitExitFullScreen", () => {
            //     console.log("myVideo.webkitExitFullScreen");
            // });
            //
            // myVideo.addEventListener('fullscreenchange', (event) => {
            //     console.log("myVideo.fullscreenchange");
            // });

            myVideo.addEventListener("webkitendfullscreen", () => {
                setTimeout(() => {
                    this.showControls();
                    this.fullscreen = false;
                    this.paused = true;
                    myVideo.pause();
                    $scope.$apply();
                }, 150);
            });

            myVideo.addEventListener('volumechange', (event) => {
                this.muted = myVideo.muted;
                $scope.$apply();
            });

            myRange.addEventListener('input', (event) => {
                document.documentElement.style.setProperty('--bunny-ratio', parseInt(event.target.value / myVideo.duration * 100 ) + "%");
                myVideo.currentTime = event.target.value;
                if ( this.playing ) {
                    this.showControls();
                    this.hideControls();
                    myVideo.play();
                }
            });

            myVolume.addEventListener('input', (event) => {
                this.volume(event.target.value);
                localStorage.setItem('bunny-volume', event.target.value);
                document.documentElement.style.setProperty('--bunny-volume', (myVideo.volume*100) + "%");
                $scope.$apply();
            });


            // Calculate preview slices
            myPreview.addEventListener('loadedmetadata',  () => {
                for ( let i in this.preview.breakpoints ) {
                    if ( this.preview.breakpoints.hasOwnProperty(i)) {
                        this.preview.slices[i] = {
                            start: parseInt(i) !== 0 ? this.preview.breakpoints[i-1] : 0,
                            finish: this.preview.breakpoints[i],
                        };
                        this.preview.slices[i].seek = Math.round( (this.preview.slices[i].start + this.preview.slices[i].finish) / 2 * ( myPreview.duration/100 ));
                    }
                }
            });

            // Display the preview
            myRange.addEventListener('mousemove', (e) => {

                // Get DOMRect object
                let rectangle = e.target.getBoundingClientRect();

                // Mouse x position within the element.
                let position = e.clientX - rectangle.left;


                // console.log("Offset: " + container);
                this.preview.percentage = Math.round( position * 100/  e.target.offsetWidth);

                this.preview.time = this.toHHMMSS( myVideo.duration * this.preview.percentage / 100 );

                for ( let i in this.preview.slices ) {
                    if ( this.preview.slices.hasOwnProperty(i) && this.preview.percentage > this.preview.slices[i].start && this.preview.percentage < this.preview.slices[i].finish ) {
                        this.preview.current = i;
                        break;
                    }
                }

                // Play only when breakpoint changes
                if (this.preview.previous !== this.preview.current ) {
                    myPreview.currentTime = this.preview.slices[this.preview.current].seek;
                    myPreview.play();

                    this.preview.previous = this.preview.current;
                }

                // Position
                //e.target.offsetWidth

                let previewWidth = myPreview.clientWidth;
                let marginLeft = 0;
                if ( position < previewWidth/2 ) {
                    marginLeft = 0;
                } else {
                    marginLeft = position - previewWidth/2;
                }

                if ( position > e.target.offsetWidth - previewWidth/2 ) {
                    marginLeft = e.target.offsetWidth - previewWidth;
                }
                if (!$scope.device.mobile) {
                    myPreview.parentNode.style.display = 'flex';
                    myPreview.parentNode.style.left = marginLeft + 'px';
                }



                // console.log(marginLeft);
                // console.log("xxx", );
                // console.log(p);
            });
            // Pause the preview
            myRange.addEventListener('mouseleave', function () {
                myPreview.parentNode.style.display = 'none';
                myPreview.pause();
            });

            myPreview.addEventListener("timeupdate", () => {
                if ( myPreview.currentTime >=  this.preview.slices[this.preview.current].seek + 1 ) {
                    myPreview.pause();
                }
            });

            this.containerEvents();
            this.keyboardEvents();
            this.overlayEvents();

            if (!this.initiated) {
                this.videoElement.poster = this.poster;
                this.videoElement.load();
                this.initiated = true;
            }
        },
        containerEvents() {
            myContainer.dataset.active = "true";
            if (('ontouchstart' in document.documentElement)) {
                return false;
            }
            myContainer.addEventListener('mousemove', () => {
                if ( !this.paused && this.started ) {
                    this.showControls();
                    this.hideControls();
                }
            });

            myContainer.addEventListener('mouseleave', () => {
                if ( !this.paused && this.started ) {
                    this.hideControls();
                }
            });

        },
        keyboardEvents() {
            document.addEventListener('keydown', (event) => {
                if (event.target === document.body) {
                    switch (event.key) {
                        case " ":  event.preventDefault(); this.playPause(); break;
                        case "ArrowRight":  event.preventDefault(); myVideo.currentTime = myVideo.currentTime + 10; break;
                        case "ArrowLeft":  event.preventDefault(); myVideo.currentTime = myVideo.currentTime - 10; break;
                    }
                }
            });
        },
        overlayEvents() {
            let clicks = 0;
            myOverlayDesktop.addEventListener('click', () => {
                if (++clicks === 1) {
                    setTimeout(() => {
                        // Single click
                        if(clicks === 1) {
                            this.playPause();
                        } else {
                            this.makeFullScreen();
                        }
                        clicks = 0;
                    }, 250);
                }
            });

            myOverlayMobile.addEventListener('touchend', (event) => {
                event.preventDefault();
                let position = this.touchedPosition(event);
                let slice = myOverlayMobile.offsetWidth / 3;
                if (++clicks === 1) {
                    setTimeout(() => {
                        // Single tap
                        if(clicks === 1) {
                            if (!this.controls.visible) {
                                this.showControls();
                                this.hideControls();
                            } else {
                                this.hideControls(250);
                            }
                        } else {
                            if ( position.x < slice) {
                                myVideo.currentTime = myVideo.currentTime - 10;
                                this.arrows.backwards = true;
                                setTimeout(() => {
                                    this.arrows.backwards = false;
                                }, 500);
                            }
                            if ( position.x > slice * 2) {
                                myVideo.currentTime = myVideo.currentTime + 10;
                                this.arrows.forwards = true;
                                setTimeout(() => {
                                   this.arrows.forwards = false;
                                }, 500);
                            }
                        }
                        clicks = 0;
                    }, 250);
                }
            });

        },
        touchedPosition(e) {
            if(e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
                let event = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
                let touch = event.touches[0] || event.changedTouches[0];
                return {
                    x: touch.pageX,
                    y: touch.pageY,
                }
            } else if (e.type === 'mousedown' || e.type === 'mouseup' || e.type === 'mousemove' || e.type === 'mouseover'|| e.type === 'mouseout' || e.type === 'mouseenter' || e.type === 'mouseleave') {
                return {
                    x: e.clientX,
                    y: e.clientY,
                }
            }
        },

        toHHMMSS ( sec_num ) {
            sec_num = parseInt(sec_num);
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            if ( sec_num >= 3600 ) {
                return hours+':'+minutes+':'+seconds;
            }
            return minutes+':'+seconds;
        },
        bubbleEvents ( delay = 0) {
            clearInterval(this.bubbles.interval);
            clearTimeout(this.bubbles.timeout);
            clearTimeout(this.bubbles.restartOne);
            clearTimeout(this.bubbles.restartTwo);
            this.bubbles.length = $scope.service.video.bubbles.items.length - 1;


            this.bubbles.restartOne = setTimeout(() => {
                this.bubbleRoller();
            }, delay );

            this.bubbles.restartTwo = setTimeout(() => {
                this.bubbles.interval = setInterval(() => {
                    this.bubbleRoller();
                }, this.bubbles.time.hidden );
            }, delay + this.bubbles.time.visible );
        },

        bubbleRoller() {
            angular.forEach($scope.service.video.bubbles.items, (item, key) => {
                item.visible = key === this.bubbles.index;
                item.active = key === this.bubbles.index;
                item.slideOut = false;
            });
            $scope.$apply();

            clearTimeout(this.bubbles.timeout);
            this.bubbles.timeout = setTimeout(() => {
                $scope.service.video.bubbles.items[this.bubbles.index].active = false;
                $scope.service.video.bubbles.items[this.bubbles.index].slideOut = true;
                $http.post($scope.service.video.bubbles.track.view);
                $scope.$apply();
                if ( this.bubbles.index + 1 === this.bubbles.length ) {
                    this.bubbles.index = 0;
                } else {
                    this.bubbles.index ++;
                }
            }, this.bubbles.time.visible );
        },

        bubbleClicked() {
            $http.post($scope.service.video.bubbles.track.click);
        }
    };


    $scope.roll = {
        muted: false,
        progress: 0,
        skipRemain: 5,
        skipDelay: 5,
        skipShow: false,
        media: {},
        available: false,
        started: false,
        finished: false,
        videoElement: null,
        autoplay() {
            setTimeout(() => {
                this.videoElement.muted = true;
                myVideo.muted = true;
                this.play();
                $scope.$apply();
            }, 250 );
        },
        play() {
            this.muted = this.videoElement.muted;
            if ( $scope.roll.started || $scope.roll.finished ) {
                return false;
            }
            if (  $scope.roll.available ) {
                $scope.roll.started = true;
                vastTracker.trackImpression();
                vastTracker.track('start');
            } else  {
                $scope.bunny.playPause();
            }
        },
        skip() {
            $scope.roll.available = false;
            $http.get('/service/dismiss?dismiss=pre-roll').then(() => {
                $scope.bunny.playPause();
            });
            vastTracker.track('skip');
        },
        click() {
            vastTracker.click();
        },
        toggleMuted() {
            this.videoElement.muted = !this.videoElement.muted;
            this.muted = this.videoElement.muted;
        },
    };

    $scope.postRoll = {
        progress: 0,
        skipRemain: 5,
        skipDelay: 5,
        skipShow: false,
        media: {},
        available: false,
        started: false,
        finished: false,
        play() {
            if (  $scope.postRoll.available && !($scope.postRoll.started || $scope.postRoll.finished)) {
                $scope.postRoll.started = true;
                vastPostRollTracker.trackImpression();
                vastPostRollTracker.track('start');
            }
        },
        skip() {
            $scope.postRoll.available = false;
            $scope.postRoll.finished = true;
            vastPostRollTracker.track('skip');
        },
        click() {
            vastPostRollTracker.click();
        },
    };


    $scope.$watch('roll.finished', (value) => {
        if ( value === true) {
            $http.get('/service/dismiss?dismiss=pre-roll').then(() => {
                $scope.bunny.playPause();
                vastTracker.complete();
            });
        }
    });

    $scope.$watch('roll.started', (value) => {
        if ( value === true) {
            $http.get('/service/dismiss?dismiss=pre-roll');
        }
    });

    $scope.$watch('roll.progress', (value) => {
        if ( parseInt(value) === 50 ) {
            vastTracker.track('midpoint');
        }
    });

    $scope.$watch('service.ready', function (ready) {
        if ( ready === true) {
            // // Pre-Roll check
            // if ( $scope.service.preRoll.visible ) {
            //     vastClient.get($scope.service.preRoll.vast).then(res => {
            //         if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
            //             return false;
            //         }
            //         vastTracker = new VASTTracker(vastClient, res.ads[0], res.ads[0].creatives[0]);
            //         vastTracker.load();
            //
            //         $scope.roll.available = true;
            //         $scope.roll.media = res.ads[0].creatives[0].mediaFiles[0];
            //         $scope.roll.clickthrough = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;
            //         if ( $scope.service.preRoll.autoplay ) {
            //             $scope.roll.autoplay();
            //         }
            //         $scope.$apply();
            //     });
            // }
            //
            // // Post roll check
            // if ( $scope.service.postRoll.visible ) {
            //     vastPostRollClient.get($scope.service.postRoll.vast).then(res => {
            //         if ( res.hasOwnProperty('ads') === false || res.ads.length === 0 ) {
            //             return false;
            //         }
            //         vastPostRollTracker = new VASTTracker(vastPostRollClient, res.ads[0], res.ads[0].creatives[0]);
            //         vastPostRollTracker.load();
            //
            //         $scope.postRoll.available = true;
            //         $scope.postRoll.media = res.ads[0].creatives[0].mediaFiles[0];
            //         $scope.postRoll.clickthrough = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;
            //
            //         $scope.$apply();
            //     });
            //}

            $scope.bunny.poster = $scope.service.player.poster;
            $scope.bunny.preview.url = $scope.service.player.preview.url;
            $scope.bunny.sources.available = $scope.service.player.videos;

        }
    });


}];

export default BunnyController;
